import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AppBarWithActionButtons } from '../../../../components/designe/app-bars/app-bar-with-buttons/AppBarWithActionButtons';
import ViewField from '../../../../components/reusable/view-field/ViewField';
import { useNavigationStack } from '../../../../context/NavigationStackContext';
import { useUserConfig } from '../../../../context/UserConfigContext';
import { Paths } from '../../../../shared/paths';
import { useStyles } from './NotificationsView.styles';

export default function NotificationsView() {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { replace } = useNavigationStack();
  const { options } = useUserConfig();

  const yesNo = (on: boolean) => (on ? t('common.yes') : t('common.no'));

  return (
    <div className={classes.wrapper}>
      <Box className={classes.content}>
        <Box>
          <ViewField
            label={t('settings.notifications.system')}
            value={yesNo(options.notificationsSystemPushEnabled)}
            noShadow
            className={classes.viewItem}
          />
        </Box>
        <Box>
          <ViewField
            label={t('settings.notifications.social')}
            value={yesNo(options.notificationsSocialPushEnabled)}
            noShadow
            className={classes.viewItem}
          />
        </Box>
        <Box>
          <ViewField
            label={t('settings.notifications.marketing')}
            value={yesNo(options.notificationsMarketingPushEnabled)}
            noShadow
            className={classes.viewItem}
          />
        </Box>
        <Box>
          <ViewField
            label={t('settings.notifications.reminders')}
            value={yesNo(options.notificationsRemindersPushEnabled)}
            noShadow
            className={classes.viewItem}
          />
        </Box>
        <Box className={classes.buttonWrapper}>
          <AppBarWithActionButtons
            onEditClick={() => replace(Paths.settings.toNotificationsEdit)}
          />
        </Box>
      </Box>
    </div>
  );
}
